import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {HelperService} from "app_sasha/shared/services/helper.service";
import {NotificationModule} from "libraries/component/notification/notification.module";
import {ProcessingModule} from "../processing/processing.module";
import {ProcessingListComponent} from "./processing-list.component";

@NgModule({
    imports:[
        CommonModule,
        NotificationModule,
        ProcessingModule,
    ],
    declarations:[
        ProcessingListComponent,
    ],
    exports:[
        ProcessingListComponent,
    ],
    providers:[
        HelperService,
    ]
})
export class ProcessingListModule { }